import { render } from "./Buttons.vue?vue&type=template&id=3852ab56&scoped=true&ts=true"
import script from "./Buttons.vue?vue&type=script&lang=ts"
export * from "./Buttons.vue?vue&type=script&lang=ts"

import "./Buttons.vue?vue&type=style&index=0&id=3852ab56&scoped=true&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3852ab56"]])

export default __exports__